import React from 'react';
import { Button, Flex, Icon, Text } from '@spothero/ui';
import { ChevronLeft as IconChevronLeft, ChevronRight as IconChevronRight, } from '@spothero/icons';
import dayjs from 'utils/dayjs';
const MultiSelectDatePickerHeader = ({ date, nextMonthButtonDisabled, prevMonthButtonDisabled, decreaseMonth, increaseMonth, }) => {
    const monthYear = dayjs(date).format('MMMM YYYY');
    return (<Flex justify="space-between" paddingX="3.5">
            <Button variant="tertiary" disabled={prevMonthButtonDisabled} onClick={decreaseMonth} data-testid="MultiSelectDatePickerHeader-prev-month-button">
                <Icon as={IconChevronLeft} data-testid="MultiSelectDatePickerHeader-left-chevron-icon"/>
            </Button>
            <Text fontWeight="semibold" fontSize="xl" data-testid="MultiSelectDatePickerHeader-month-year-text">
                {monthYear}
            </Text>
            <Button variant="tertiary" disabled={nextMonthButtonDisabled} onClick={increaseMonth} data-testid="MultiSelectDatePickerHeader-next-month-button">
                <Icon as={IconChevronRight} data-testid="MultiSelectDatePickerHeader-right-chevron-icon"/>
            </Button>
        </Flex>);
};
export default MultiSelectDatePickerHeader;
